import { Components } from '@mui/material/styles';

import { colors } from 'theme/colors';
import { REGULAR } from 'theme/fonts';

const breadcrumb: Components['MuiBreadcrumbs'] = {
  styleOverrides: {
    root: {
      fontFamily: `${REGULAR}, sans-serif`,
      fontSize: '14px',
      lineHeight: '20px',
    },
    ol: {
      flexWrap: 'nowrap',
    },
    separator: {
      margin: '0 8px',
      color: colors.text.secondary,
      fontSize: '14px',
    },
    li: {
      display: 'flex',
      alignItems: 'center',
    },
  },
};

export default breadcrumb;
